<template>
  <div
    class="main-menu menu-fixed menu-accordion menu-shadow"
    :class="[
      { 'expanded': !isVerticalMenuCollapsed || (isVerticalMenuCollapsed && isMouseHovered) },
      skin === 'semi-dark' ? 'menu-dark' : 'menu-light'
    ]"
    @mouseenter="updateMouseHovered(true)"
    @mouseleave="updateMouseHovered(false)"
  >
    <!-- main menu header-->
    <span class="main-menu-page-version">V-2.1.0</span>
    <div class="navbar-header expanded">
      <slot
        name="header"
        :toggleVerticalMenuActive="toggleVerticalMenuActive"
        :toggleCollapsed="toggleCollapsed"
        :collapseTogglerIcon="collapseTogglerIcon"
      >
        <ul class="nav navbar-nav flex-row">

          <!-- Logo & Text -->
          <li class="nav-item mr-auto">
            <b-link
              class="navbar-brand"
              to="/"
            >
              <img :src="logoUrl" alt="" style="height:25px">
            </b-link>
          </li>

          <!-- Toggler Button -->
          <li class="nav-item nav-toggle">
            <b-link class="nav-link modern-nav-toggle">
              <feather-icon
                icon="XIcon"
                size="20"
                class="d-block d-xl-none"
                @click="toggleVerticalMenuActive"
              /><!-- MenuIcon -->
              <feather-icon
                :icon="collapseTogglerIconFeather"
                size="20"
                class="d-none d-xl-block collapse-toggle-icon"
                @click="toggleCollapsed"
                style="color:#13A649"
              />
            </b-link>
          </li>
        </ul>
      </slot>
    </div>
    <!-- / main menu header-->

    <!-- Shadow -->
    <div
      :class="{'d-block': shallShadowBottom}"
      class="shadow-bottom"
    />

    <!-- main menu content-->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="main-menu-content scroll-area"
      tagname="ul"
      @ps-scroll-y="evt => { shallShadowBottom = evt.srcElement.scrollTop > 0 }"
    >
      <vertical-nav-menu-items
        :items="navMenuItems"
        class="navigation navigation-main"
      />
    </vue-perfect-scrollbar>
    <!-- /main menu content-->
    
  </div>
</template>

<script>
// import navMenuItems from '@/navigation/vertical'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { BLink, BImg } from 'bootstrap-vue'
import { provide, computed, ref } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import { $themeConfig } from '@themeConfig'
import VerticalNavMenuItems from './components/vertical-nav-menu-items/VerticalNavMenuItems.vue'
import useVerticalNavMenu from './useVerticalNavMenu'
import store from '@/store'
import { onMounted } from '@vue/composition-api'
import config from "../../../../../config/index"

export default {
  components: {
    VuePerfectScrollbar,
    VerticalNavMenuItems,
    BLink,
    BImg,
  },
  props: {
    isVerticalMenuActive: {
      type: Boolean,
      required: true,
    },
    toggleVerticalMenuActive: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    // onMounted(async()=>{
    //    await store.dispatch('verticalMenu/updateRouteList')
    // })
    const logoUrl = config.logoUrl
    const {
      isMouseHovered,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      updateMouseHovered,
    } = useVerticalNavMenu(props)

    const { skin } = useAppConfig()

    // Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
    const shallShadowBottom = ref(false)

    provide('isMouseHovered', isMouseHovered)

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    const collapseTogglerIconFeather = computed(() => (collapseTogglerIcon.value === 'unpinned' ? 'CircleIcon' : 'DiscIcon'))

    // App Name
    const { appName, appLogoImage } = $themeConfig.app
    // const navMenuItems = computed(() => store.state.verticalMenu.newRoute)
    let navMenuItems = ref([]);
    onMounted(async()=>{
      //  await store.dispatch('verticalMenu/updateRouteList')
      //  navMenuItems.value = store.state.verticalMenu.newRoute
        store.dispatch('verticalMenu/getUserRoleMenu').then(async response => {
          if(response && response.length) {
            await store.dispatch('verticalMenu/updateRouteList')
            navMenuItems.value = store.state.verticalMenu.newRoute
          }
        })
    })
    console.log('vertical文件navMenuItems======', navMenuItems)
    return {
      logoUrl,
      navMenuItems,
      perfectScrollbarSettings,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      isMouseHovered,
      updateMouseHovered,
      collapseTogglerIconFeather,

      // Shadow Bottom
      shallShadowBottom,

      // Skin
      skin,

      // App Name
      appName,
      appLogoImage,
    }
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/vertical-menu.scss";
[dir] .main-menu ul{
  // width: 250px;
}
.vertical-layout.vertical-menu-modern.menu-expanded .main-menu{
  width: 250px;
}
.main-menu .navbar-header {
  width: 100%;
}
html[dir=ltr] .content{
  margin-left: 250px;
}
ul.nav.navbar-nav.flex-row{
  width: 100%;
}
html[dir] .content.app-content {
    // padding: calc(1rem + 4.45rem + 1.3rem) 1.2rem 0;
    // padding: calc(4.45rem + 1.25rem) 1.25rem 0;
    padding: 79px 20px 0;
}
[dir=ltr] .main-menu.menu-light .navigation > li ul .active {
  background: #35B871;
}
[dir] .main-menu.menu-light .navigation > li ul .active {
  box-shadow: none;
}
[dir] .customizer .customizer-toggle{
  background: #35B871;
}
.main-menu-page-version {
  position: absolute;
  left: 5px;
  bottom: 5px;
  font-size: 12px;
  color:#ccc;
}
</style>
